var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 14,
    r: 13.75,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6194 20.1703C13.2064 20.1703 12.8583 19.9963 12.5751 19.6482L8.97308 15.1612C8.86098 15.0255 8.78133 14.8957 8.73413 14.7718C8.68693 14.642 8.66333 14.5092 8.66333 14.3735C8.66333 14.0726 8.76363 13.8248 8.96423 13.6301C9.16484 13.4295 9.42149 13.3292 9.73419 13.3292C10.0823 13.3292 10.3743 13.4797 10.6104 13.7806L13.584 17.6038L19.3365 8.45282C19.4722 8.25222 19.6109 8.11062 19.7525 8.02802C19.8941 7.93951 20.0711 7.89526 20.2835 7.89526C20.5903 7.89526 20.8411 7.99261 21.0358 8.18732C21.2364 8.37612 21.3367 8.62097 21.3367 8.92188C21.3367 9.03988 21.316 9.16083 21.2747 9.28473C21.2393 9.40863 21.1774 9.53843 21.0889 9.67413L14.6637 19.6216C14.4159 19.9874 14.0678 20.1703 13.6194 20.1703Z",
    fill: "#00CE00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckWhite);
export default __webpack_public_path__ + "static/media/CheckWhite.459265919af42511b1516dc82b09afc6.svg";
export { ForwardRef as ReactComponent };